import axios from 'axios';
import { API_URL } from './config';

export const clearUserData = () => {
    localStorage.removeItem('authToken');
    sessionStorage.removeItem('authToken');
};

const axiosInstance = axios.create({
    baseURL: API_URL,
    headers: {
        // 'Content-Type': 'application/json',
    },
});

axiosInstance.interceptors.response.use(
    response => response,
    error => {
        const { response } = error;

        if (response && response.status === 401) {
            clearUserData();
            window.location.href = '/login';
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;